interface ITipptourIconProps {
    className?: string;
  }
  

const TipptourLogo: React.FC<ITipptourIconProps> = ({className}) => (
<svg width="140" height="32" viewBox="0 0 140 32" className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
        <path id="a" d="M0 0h22v27H0z"/>
        <path id="c" d="M0 0h22v27H0z"/>
        <path id="e" d="M0 0h12v20H0z"/>
        <path d="m6.22 0-.512 5.911L0 7.77v2.852h5.708v9.116c0 4.176 2.272 6.263 6.66 6.263h3.429v-5.208h-2.911c-1.756 0-2.594-.63-2.594-1.968V10.62H16V7.769l-5.708-1.858L9.79.004 6.22 0z" id="g"/>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="83.24%" id="h">
            <stop stopColor="#FFCB02" offset="0%"/>
            <stop stopColor="#6A0096" offset="100%"/>
        </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
        <path fill="#6A0096" d="M17.777 26.075h4.503V5.929h-4.503z"/>
        <g transform="translate(25 5)">
            <mask id="b" fill="#fff">
                <use xlinkHref="#a"/>
            </mask>
            <path d="M17.245 10.728c0-2.772-2.7-4.862-6.325-4.862-3.627 0-6.327 2.09-6.327 4.862 0 2.772 2.7 4.861 6.327 4.861 3.626 0 6.325-2.089 6.325-4.861m4.755 0c0 6.107-4.23 10.728-9.912 10.728-3.344 0-6.004-1.809-7.495-4.62V27H0V.482h4.593V4.62C6.083 1.808 8.743 0 12.088 0 17.77 0 22 4.62 22 10.728" fill="#6A0096" mask="url(#b)"/>
        </g>
        <g transform="translate(48 5)">
            <mask id="d" fill="#fff">
                <use xlinkHref="#c"/>
            </mask>
            <path d="M17.246 10.728c0-2.772-2.7-4.862-6.327-4.862-3.626 0-6.325 2.09-6.325 4.862 0 2.772 2.7 4.861 6.325 4.861 3.627 0 6.327-2.089 6.327-4.861m4.754 0c0 6.107-4.23 10.728-9.912 10.728-3.345 0-6.004-1.809-7.494-4.62V27H0V.482h4.594V4.62C6.084 1.808 8.744 0 12.088 0 17.77 0 22 4.62 22 10.728" fill="#6A0096" mask="url(#d)"/>
        </g>
        <path d="M81.704 10.63V5.909h-5.159V0H72v19.736C72 23.912 74.253 26 78.6 26H82v-5.209h-2.885c-1.74 0-2.57-.63-2.57-1.969V10.63h5.159zM99.24 16.5c0-2.713-2.64-4.758-6.24-4.758s-6.28 2.045-6.28 4.758 2.68 4.758 6.28 4.758 6.24-2.045 6.24-4.758M82 16.5C82 10.522 86.72 6 93 6s11 4.522 11 10.5S99.28 27 93 27s-11-4.522-11-10.5M125 6v20.517h-4.57v-4.143c-1.512 3.018-3.936 4.626-7.037 4.626-4.412 0-7.393-3.057-7.393-7.683V6h4.53v11.547c0 2.131 1.91 3.58 4.81 3.58 3.021 0 5.09-1.49 5.09-3.66V6H125z" fill="#6A0096"/>
        <g transform="translate(128 6)">
            <mask id="f" fill="#fff">
                <use xlinkHref="#e"/>
            </mask>
            <path d="M12 0v6.04c-4.84 0-7.44 1.699-7.44 4.787V20H0V.31h4.56v4.902C6.16 1.97 8.76 0 12 0" fill="#6A0096" mask="url(#f)"/>
        </g>
        <g>
            <mask id="i" fill="#fff">
                <use xlinkHref="#g"/>
            </mask>
            <path d="m6.22 0-.512 5.911L0 7.77v2.852h5.708v9.116c0 4.176 2.272 6.263 6.66 6.263h3.429v-5.208h-2.911c-1.756 0-2.594-.63-2.594-1.968V10.62H16V7.769l-5.708-1.858L9.79.004 6.22 0z" fill="url(#h)" mask="url(#i)"/>
        </g>
    </g>
</svg>

  );
  
  export default TipptourLogo;
  